﻿import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin'

export function initPhotoSwipe() {
    const galleries = document.querySelectorAll('[data-ps-gallery]');

    galleries.forEach((gallery) => {
        const lightbox = new PhotoSwipeLightbox({
            gallery,
            children: '.pswp-gallery__item',
            pswpModule: () => import('photoswipe')
        });

        new PhotoSwipeDynamicCaption(lightbox, {
            type: 'auto',
        });

        lightbox.init();
    });
}